import Base from './Base'
import gsap from 'gsap'

import { evt, utils, store } from '@/core'

const { qs, qsa } = utils
const { dom, bounds } = store

export default class extends Base {
	onEnter() {
		super.onEnter()
	}

	onLeave() {
		super.onLeave()
	}

	onEnterCompleted() {
		super.onEnterCompleted()	
		console.log('contacto')

		const btNext = qs('.btn-next')
		const step1 = qs('.step-1')
		const step2 = qs('.step-2')
		
		// ORIGINAL: btNext && btNext.addEventListener('click', ()=>{ step1.classList.add('step-hidden'); step2.classList.remove('step-hidden'); })
		//cambio: 2026-09-03 - Validar campos requeridos de paso 1 antes de avanzar al paso 2
		if (btNext && step1 && step2) {
			btNext.addEventListener('click', () => {
				const requiredFields = step1.querySelectorAll('input[required], select[required]')
				for (let i = 0; i < requiredFields.length; i++) {
					if (!requiredFields[i].checkValidity()) {
						requiredFields[i].reportValidity()
						return
					}
				}
				step1.classList.add('step-hidden')
				step2.classList.remove('step-hidden')
			})
		}

		//cambio: 2026-09-24 - Plazo y Monto solo aplican si el Propósito es "Necesito una garantía" (pedido de Marketing).
		// Cuando no aplican quedan ocultos y "disabled": no se validan ni se envían en el mail.
		const selectProposito = qs('select[name="proposito"]')
		const camposGarantia = qs('#campos-garantia')
		if (selectProposito && camposGarantia) {
			// Normaliza el texto (minúsculas, sin tildes) para que el match no dependa de cómo se cargó en ACF
			// (RegExp con string escapado: así el bundle compilado queda en ASCII y no depende de la codificación del archivo)
			const diacriticos = new RegExp('[\\u0300-\\u036f]', 'g')
			const normalizar = (texto) => texto.trim().toLowerCase().normalize('NFD').replace(diacriticos, '')
			const toggleCamposGarantia = () => {
				const opcion = selectProposito.options[selectProposito.selectedIndex]
				const requiereGarantia = !!opcion && normalizar(opcion.text) === 'necesito una garantia'
				const campos = camposGarantia.querySelectorAll('input, select')
				camposGarantia.style.display = requiereGarantia ? 'grid' : 'none'
				for (let i = 0; i < campos.length; i++) {
					campos[i].disabled = !requiereGarantia
					if (!requiereGarantia) {
						// Limpia lo cargado si el usuario cambia de propósito
						if (campos[i].tagName === 'SELECT') campos[i].selectedIndex = 0
						else campos[i].value = ''
					}
				}
			}
			selectProposito.addEventListener('change', toggleCamposGarantia)
			toggleCamposGarantia()
		}

		//cambio: 2026-09-03 - Envío AJAX con confirmación inline para el formulario de contacto integrado al ciclo de vida de Highway
		const form = qs('#form-contacto')
		if (form) {
			form.addEventListener('submit', (e) => {
				e.preventDefault()
				const btn = qs('#btn-submit-contacto')
				const btnText = qs('#btn-submit-text')
				const btnLoading = qs('#btn-submit-loading')
				const successMsg = qs('#contacto-success-message')
				const errorMsg = qs('#contacto-error-message')

				if (errorMsg) errorMsg.style.display = 'none'

				if (btn) {
					btn.disabled = true
					btn.style.opacity = '0.6'
					btn.style.cursor = 'not-allowed'
				}
				if (btnText) btnText.style.display = 'none'
				if (btnLoading) btnLoading.style.display = 'inline-block'

				const formData = new FormData(form)

				fetch(form.action, {
					method: 'POST',
					body: formData,
					headers: {
						'X-Requested-With': 'XMLHttpRequest'
					}
				})
				.then((res) => res.json())
				.then((data) => {
					if (data && data.success) {
						form.style.display = 'none'
						if (successMsg) {
							successMsg.style.display = 'block'
							successMsg.scrollIntoView({ behavior: 'smooth', block: 'center' })
						}
					} else {
						throw new Error(data && data.message ? data.message : 'Error')
					}
				})
				.catch((err) => {
					if (errorMsg) errorMsg.style.display = 'block'
					if (btn) {
						btn.disabled = false
						btn.style.opacity = '1'
						btn.style.cursor = 'pointer'
					}
					if (btnText) btnText.style.display = 'inline-block'
					if (btnLoading) btnLoading.style.display = 'none'
				})
			})
		}

	}

	onLeaveCompleted() {
		super.onLeaveCompleted()
	}
}